import React from "react";
import "./LinkTo.scss";
import { NavLink } from "react-router-dom";

// props: {name:string, link:string, img:Object}
export default function LinkTo(props: any) {
  return (
    <div className={"link-to-container grid gird-cols-1 sm:grid-cols-2"}>
      {props.links.map((i: any) => {
        return (
          <div className="whitespace-nowrap link-to-item border border-[0.5px]">
            <NavLink to={i.link}>
              <img src={i.img.src} alt={i.img.alt} />
              <p className="">{i.title}</p>
            </NavLink>
          </div>
        );
      })}
    </div>
  );
}
